import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../../modules/companies/register-panels'
import '../../../../modules/contacts/register-panels'
import '../../../../modules/events/register-panels'
import { EventFullPage } from '../../../../modules/events/event-full-page'
import { PANEL_TYPES } from '../../../../shell/panel-state'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  pstack: z.string().optional(),
})

export const Route = createFileRoute('/_authed/analytics/events/$eventId')({
  validateSearch: detailSearchSchema,
  component: AnalyticsEventDetailRoute,
})

function AnalyticsEventDetailRoute() {
  const { eventId } = Route.useParams()
  return (
    <EventFullPage eventId={eventId} fallbackTo="/analytics/events" fallbackLabel="Event Stream" />
  )
}
